import { isFeature } from 'Cloud/Application/FeaturesEs6';

export const cloudOverquotaClamp = isFeature('cloud-overquota-clamp') || false;
